import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { ORG_LABELS } from '../config';
import { Tabs } from '../ui/basics';
import Clients from './directory/Clients';
import Recruiters from './directory/Recruiters';

const TABS = [{ key: 'clients', label: 'Clients' }, { key: 'recruiters', label: 'Recruiters' }];

export default function Directory() {
  const { org } = useAuth();
  const [tab, setTab] = useState('clients');
  return (
    <div className="stack">
      <div className="page-head"><div><h1>Clients & Recruiters</h1><p>{ORG_LABELS[org]} · the master lists used in placements, reports and onboarding</p></div></div>
      <Tabs tabs={TABS} value={tab} onChange={setTab} />
      {tab === 'clients' ? <Clients key={org} org={org} /> : <Recruiters key={org} org={org} />}
    </div>
  );
}
